import {
  LOGIN_ROUTE,
  VERIFY_NUMBER_ROUTE,
  RECOVER_PASSWORD_ROUTE,
  BOLSON_FORM_ROUTE,
  MICROSOFT_REDIRECT_ROUTE,
} from '../../providers/routes'
import { parseEnvFields } from '../../utils/utils'

const requiredUserFields = parseEnvFields(
  process.env.SESSION_REQUIRED_USER_FIELDS,
)

export const pushMoneyStorageConfig = {
  name: 'pushMoneyAuthValidation',
  publicPaths: [
    '/',
    { path: LOGIN_ROUTE, exact: false },
    { path: VERIFY_NUMBER_ROUTE, exact: false },
    { path: RECOVER_PASSWORD_ROUTE, exact: false },
    { path: BOLSON_FORM_ROUTE, exact: true },
    { path: `${BOLSON_FORM_ROUTE}/`, exact: true },
    { path: MICROSOFT_REDIRECT_ROUTE, exact: false },
  ],
  storages: [
    {
      key: 'pushMoneyUser',
      dataPath: 'user',
      tokenPath: 'token',
      requiredFields: requiredUserFields,
    },
  ],
  onFailure: {
    redirect: LOGIN_ROUTE,
  },
}

export default pushMoneyStorageConfig
